import React from "react";
import classNames from "classnames";
import Icon from "../Icon";
import { getOtherProperties } from "../common/Utils";
import { ChipProps } from "./PropsType";

export default function Chip(props: ChipProps) {
  const { active = false, avatar, className, close, label, ...other } = props;
  const styleClass = classNames(
    "Chip",
    {
      "Chip-active": active,
    },
    className
  );
  const otherProps = getOtherProperties(other, ["onClick", "onDelete"]);

  const handleDelete = () => {
    if (props.onDelete) {
      props.onDelete({
        label: props.label!,
        value: props.value!,
      });
    }
  };

  const handleClick = () => {
    if (props.onClick) {
      props.onClick({
        label: props.label!,
        value: props.value!,
      });
    }
  };

  return (
    <div className={styleClass} {...otherProps} onClick={handleClick}>
      {avatar ? <span className="Chip-avatar">{avatar}</span> : null}
      <span className="Chip-inner">{label}</span>
      {close ? (
        <Icon className="Chip-close" icon="close" onClick={handleDelete} />
      ) : null}
    </div>
  );
}
